import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { volumes } from '../data/volumes';
import { FlowLine } from './FlowLine';
import { Ornament } from './Ornament';
export function TomosSection() {
  return <section className="border-t border-primary/10 bg-surface px-4 py-20 sm:py-28" data-id="element-357" data-mp="1p4c0q4oesgv8">
      <div className="mx-auto max-w-6xl" data-id="element-358" data-mp="1u1bzduixihcb">
        <div className="mx-auto max-w-3xl text-center" data-id="element-359" data-mp="xce1i3fvu3ax">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-primary" data-id="element-360" data-mp="xdyvnryabk89">
            The 6 volumes
          </p>
          <h2 className="mt-3 text-3xl font-semibold text-foreground sm:text-4xl" data-id="element-361" data-mp="11fstztl0cc59">
            The Complete <span className="italic text-primary" data-id="element-362" data-mp="16f5ck24uix21">6-Volume</span>{' '}
            Stretching Instructor System
          </h2>
          <Ornament className="mt-5" data-id="element-363" data-mp="2hshlgrfgq5v2" />
        </div>
        <div className="mt-14 grid gap-6 md:grid-cols-2" data-id="element-364" data-mp="2hrptrrozksa2">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.1
        }} transition={{
          duration: 0.3,
          delay: index % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className={`flex h-full flex-col rounded-xl border border-accent/30 p-6 shadow-card sm:p-8 ${index % 2 === 0 ? 'bg-background' : 'bg-surface-subtle'}`} data-id="element-365" data-mp="2mphiydy8y0ak" data-mpi={index}>
              <div className="flex items-center justify-between gap-3" data-id="element-366" data-mp="22y4h3ejc1wsp">
                <p className="font-display text-sm font-semibold uppercase tracking-[0.16em] text-primary" data-id="element-367" data-mp="1yx2fir1y18nk">
                  {volume.number}
                </p>
                {volume.classes && <span className="inline-flex whitespace-nowrap rounded-full border border-accent/50 bg-surface px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.1em] text-primary-strong" data-id="element-368" data-mp="1oyvclc4hor4k">
                    {volume.classes}
                  </span>}
              </div>
              <span className="mt-3 block h-px w-12 bg-accent" aria-hidden="true" data-id="element-369" data-mp="1fb99k6c5jbuj" />
              <h3 className="mt-4 text-2xl font-semibold leading-snug text-foreground" data-id="element-370" data-mp="1f96akwt0u8do">
                {volume.title}
              </h3>
              <p className="mt-3 border-l-2 border-accent pl-4 text-sm font-medium leading-6 text-primary-strong" data-id="element-371" data-mp="15cjracgcfpdr">
                {volume.subtitle}
              </p>
              <div className="mt-6" data-id="element-372" data-mp="1t50aiqbthnen">
                {volume.problem.map((paragraph, pIndex) => <p key={paragraph} className={`text-sm leading-6 text-muted-foreground ${pIndex > 0 ? 'mt-2' : ''}`} data-id="element-373" data-mp="1y3l9kmfc211i" data-mpi={pIndex}>
                    {paragraph}
                  </p>)}
              </div>
              {volume.extraList && <ChecklistBlock label={volume.extraList.label} items={volume.extraList.items} data-id="element-374" data-mp="2gs8en4xieqf3" />}
              <ChecklistBlock label={volume.listLabel} items={volume.bullets} data-id="element-375" data-mp="5bgaypu4q3fs" />
              {volume.flow && <FlowLine className="mt-6" label={volume.flow.label} steps={volume.flow.steps} data-id="element-376" data-mp="c3o4539cwd7" />}
              {volume.highlight && <ChecklistBlock label={volume.highlight.label} items={volume.highlight.items} data-id="element-377" data-mp="3ijt7076pkk4a" />}
              <div className="mt-auto pt-7" data-id="element-378" data-mp="3dmj6nwhs6o1o">
                <div className="rounded-lg border border-primary/20 bg-muted p-4 text-sm leading-6 text-foreground" data-id="element-379" data-mp="3shpb4f18aesw">
                  <strong className="font-semibold text-primary-strong" data-id="element-380" data-mp="3nimhdqqp7v08">
                    Result:{' '}
                  </strong>
                  {volume.result.join(' ')}
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}
function ChecklistBlock({
  label,
  items
}: {
  label?: string;
  items: string[];
}) {
  return <div className="mt-5" data-id="element-381" data-mp="3df8sqeb63yj7">
      {label && <p className="text-sm font-semibold text-foreground" data-id="element-382" data-mp="3dgagnjda8fic">{label}</p>}
      <ul className="mt-2 grid gap-x-4 gap-y-1.5 sm:grid-cols-2" data-id="element-383" data-mp="3hgkkoqhikvuk">
        {items.map(item => <li key={item} className="flex gap-2.5 text-sm leading-6 text-muted-foreground" data-id="element-384" data-mp="3mhrsgpjnpv18">
            <CheckIcon size={16} className="mt-1 shrink-0 text-success" aria-hidden="true" data-id="element-385" data-mp="3rgl7wnii7w41" />
            {item}
          </li>)}
      </ul>
    </div>;
}